import delta from "@/assets/images/services/erp-implementation/delta.webp";
import samagra from "@/assets/images/services/erp-implementation/samgura.webp";
import pksImage from "@/assets/images/services/erp-implementation/pks-eng.webp";
import collman from "@/assets/images/services/erp-implementation/collman.webp";
import kankriya from "@/assets/images/services/erp-implementation/kankriya.webp";

import mapping from "@/assets/icons/services/erp/implementation/mapping.svg";
import configuration from "@/assets/icons/services/erp/implementation/configuration.svg";
import custom from "@/assets/icons/services/erp/implementation/custom.svg";
import migration from "@/assets/icons/services/erp/implementation/migration.svg";
import integration from "@/assets/icons/services/erp/implementation/integration.svg";
import testing from "@/assets/icons/services/erp/implementation/testing.svg";
import training from "@/assets/icons/services/erp/implementation/training.svg";
import support from "@/assets/icons/services/erp/implementation/support.svg";

import implement from "@/assets/icons/services/erp/commit/implement.svg";
import dataMigration from "@/assets/icons/services/erp/commit/migration.svg";
import scope from "@/assets/icons/services/erp/commit/scope.svg";
import document from "@/assets/icons/services/erp/commit/document.svg";

import businessIcon from "@/assets/icons/services/erp/whychoose/business.svg";
import technicalIcon from "@/assets/icons/services/erp/whychoose/technical.svg";
import industryIcon from "@/assets/icons/services/erp/whychoose/industry.svg";
import supportIcon from "@/assets/icons/services/erp/whychoose/support.svg";

import odooInterfaceImage from "@/assets/images/services/erp-implementation/interface.webp";
import odooWorkflowImage from "@/assets/images/services/erp-implementation/workflow.webp";
import odooManualImage from "@/assets/images/services/erp-implementation/manual.webp";
import odooLowcodeImage from "@/assets/images/services/erp-implementation/lowcode.webp";
import mobileAccessImage from "@/assets/images/services/erp-implementation/mobile-access.webp";
import productionImage from "@/assets/images/services/erp-implementation/production.webp";

import inventory from "@/assets/icons/services/erp/module/inventory.svg";
import purchase from "@/assets/icons/services/erp/module/purchase.svg";
import finance from "@/assets/icons/services/erp/module/finance.svg";
import sales from "@/assets/icons/services/erp/module/sales.svg";
import project from "@/assets/icons/services/erp/module/project.svg";
import hr from "@/assets/icons/services/erp/module/hr.svg";
import automation from "@/assets/icons/services/erp/module/automation.svg";
import website from "@/assets/icons/services/erp/module/website.svg";
import customize from "@/assets/icons/services/erp/module/customize.svg";
import manufacturing from "@/assets/icons/services/erp/module/manufacturing.svg";

import manufacturingIcon from "@/assets/icons/services/erp/industry/manufacturing.svg";
import solarIcon from "@/assets/icons/services/erp/industry/solar.svg";
import constructionIcon from "@/assets/icons/services/erp/industry/construction.svg";
import foodIcon from "@/assets/icons/services/erp/industry/food.svg";
import retailIcon from "@/assets/icons/services/erp/industry/retail.svg";
import estateIcon from "@/assets/icons/services/erp/industry/estate.svg";
import logisticsIcon from "@/assets/icons/services/erp/industry/van.svg";
import wholesalerIcon from "@/assets/icons/services/erp/industry/wholesaler.svg";
import pointOfSaleIcon from "@/assets/icons/services/erp/industry/point.svg";
import solutionIcon from "@/assets/icons/services/erp/industry/demand.svg";
import offlineIcon from "@/assets/icons/services/erp/industry/offline.svg";
import travelIcon from "@/assets/icons/services/erp/industry/travel.svg";

import savingIcon from "@/assets/icons/services/erp/measure/saving.svg";
import increasedIcon from "@/assets/icons/services/erp/measure/increased.svg";
import decisionIcon from "@/assets/icons/services/erp/measure/decision.svg";
import roiIcon from "@/assets/icons/services/erp/measure/roi.svg";

import businessImage from "@/assets/images/services/erp-implementation/business.webp";
import meetingImage from "@/assets/images/services/erp-implementation/meeting.webp";
import businessPeopleImage from "@/assets/images/services/erp-implementation/business-people.webp";
import officeImage from "@/assets/images/services/erp-implementation/office.webp";
import peopleImage from "@/assets/images/services/erp-implementation/people.webp";
import teamImage from "@/assets/images/services/erp-implementation/team.webp";
import teamMeetingImage from "@/assets/images/services/erp-implementation/team-meeting.webp";

const erpServices = {
  "odoo-erp-implementation": {
    slug: "odoo-erp-implementation",
    name: "ERP Implementation",
    hero: {
      title: "Advanced Odoo ERP Implementation",
      description:
        "All-in-One Business Management Platform for Complete Control and Visibility. Unify your entire business with a powerful.",
    },

    impact: {
      title: 'Companies We’re Proud to "Work" With',
      description:
        "Every client relationship reflects our commitment to quality, innovation, and measurable business impact.",
      cases: [
        {
          id: "delta",
          name: "DELTA",
          image: delta,
          location: "Dindigul",
          industry: "Pooja Products Manufacturing",
        },
        {
          id: "samagra",
          name: "Samagra",
          image: samagra,
          location: "Telangana",
          industry: "Trading",
        },
        {
          id: "pks-engineering",
          name: "PKS Engineering",
          image: pksImage,
          location: "Madurai",
          industry: "Engineering & Manufacturing",
        },
        {
          id: "collman",
          name: "Collman",
          image: collman,
          location: "Chennai",
          industry: "Engineering & Manufacturing",
        },
        {
          id: "kankiriya-2",
          name: "Kankiriya",
          image: kankriya,
          location: "Chennai",
          industry: "Manufacturing",
        },
      ],
    },

    implementation: {
      title: 'What "Implementation" Means',

      description:
        'Not "we installed the software." This.<br />A lot of vendors use "implementation" loosely. Here\'s exactly what\'s inside ours.',
      features: [
        {
          icon: mapping,
          title: "Process mapping",
          description: "How work happens today - not what the org chart says. ",
        },
        {
          icon: configuration,
          title: "Module selection & configuration",
          description:
            "Sales, CRM, Inventory, Accounting, Manufacturing, HR, POS, and 30+ others, set up around your workflow. ",
        },
        {
          icon: custom,
          title: "Custom development ",
          description:
            "For the 10–20% of processes that are genuinely unique to your business. ",
        },
        {
          icon: migration,
          title: "Data migration  ",
          description:
            "Legacy data cleaned, mapped, and validated, not just exported and dumped in. ",
        },
             {
          icon: integration,
          title: "Integrations",
          description: "Payment gateways, Shopify / WooCommerce / Magento, shipping carriers, banking, BI tools. ",
        },
        {
          icon: testing,
          title: "Testing & UAT ",
          description:
            "Real users running real transactions before go-live - not a demo click-through. ",
        },
        {
          icon: training,
          title: "Training & change management ",
          description:
            "The system only works if people use it. This is where adoption is won or lost. ",
        },
        {
          icon: support,
          title: "Go-live support ",
          description:
            "The first 30–60 days after launch are where issues surface. We're on standby. ",
        },
      ],
    },
    businessModule: {
      title: "Odoo Business Modules",
      description:
        "Bring every function of your business into one connected system with modules built for efficiency, control, and scalability. Eliminate data silos by connecting every department on a single platform that works in sync. Automate routine processes to reduce manual effort and improve accuracy across operations. Gain real-time visibility into your data to make faster and more confident decisions. Scale your business seamlessly with a flexible system designed to grow with your needs.",

      modules: [
        {
          id: 1,
          icon: inventory,
          title: "Inventory & Warehouse",
          description: "Real-Time Stock Control",
        },
        {
          id: 2,
          icon: purchase,
          title: "Purchase",
          description: "Smart Vendor Handling",
        },
        {
          id: 3,
          icon: finance,
          title: "Accounting Finance",
          description: "Accurate Financial Insights",
        },

        {
          id: 4,
          icon: sales,
          title: "Sales & CRM",
          description: "Lead to Conversion",
        },
        {
          id: 5,
          icon: project,
          title: "Project Management",
          description: "Track Tasks Easily",
        },
        {
          id: 6,
          icon: hr,
          title: "Human Resources",
          description: "Manage Workforce Efficiently",
        },
        {
          id: 7,
          icon: automation,
          title: "Marketing Automation",
          description: "Automate Customer Engagement",
        },
        {
          id: 8,
          icon: website,
          title: "E-commerce Website",
          description: "Sell Online Seamlessly",
        },
        {
          id: 9,
          icon: customize,
          title: "Customization",
          description: "Flexible System Expansion",
        },
        {
          id: 10,
          icon: manufacturing,
          title: "Manufacturing",
          description: "Efficient Production Planning",
        },
      ],
    },

    BeforeYouCommit: {
      title: 'Before you commit Do you need a full "implementation?"',
      description:
        "Not every business needs a 90-day project. Answer honestly. Running more than 2 disconnected tools for sales, inventory, or accounting today? ",
      implementation: [
        {
          icon: implement,
          title: "Full Implementation likely Fits",
          description:
            "Just need 1–2 modules configured well - e.g. Inventory + Accounting? ",
        },
        {
          icon: dataMigration,
          title: "You'll Need Dedicated Data Migration ",
          description: "Team under 10 people with simple workflows? ",
        },
        {
          icon: scope,
          title: "A Scoped Faster, Engagement Fits Better ",
          description:
            "Migrating off another ERP, SAP, NetSuite, QuickBooks, or an old Odoo version? ",
        },
        {
          icon: document,
          title: "Standard Config May be Enough - We'll Say So",
          description: "Take the 2-Minute Fit Assessment",
        },
      ],
    },
    expertise: {
      title: "Our Industry Expertise",
      description:
        "Step into Industry 4.0 with ERP solutions that automate processes, connect departments, and provide real-time business insights. Build a smarter, faster, and more efficient organization ready for future growth.",
      industries: [
        {
          icon: manufacturingIcon,
          title: "Manufacturing",
        },
        {
          icon: solarIcon,
          title: "Solar",
        },
        {
          icon: constructionIcon,
          title: "Construction",
        },
        {
          icon: foodIcon,
          title: "Food & Restaurant",
        },
        {
          icon: retailIcon,
          title: "Retail",
        },
        {
          icon: estateIcon,
          title: "Real Estate",
        },
        {
          icon: logisticsIcon,
          title: "logistics & Distribution",
        },
        {
          icon: pointOfSaleIcon,
          title: "Point-of-Sale",
        },
        {
          icon: solutionIcon,
          title: "On-Demand Solutions",
        },
        {
          icon: offlineIcon,
          title: "Offline Businesses",
        },
        {
          icon: wholesalerIcon,
          title: "Wholesale Distribution Business",
        },
        {
          icon: travelIcon,
          title: "Travel & Hospitality",
        },
      ],
    },

    process: {
      title: 'Our "process" ',
      description: "Five phases. Roughly 90 days to go-live. You see working software every two weeks, not one reveal at the end",

      processData: [
        {
          section: "01",
          title: "PHASE - 01",
          description: "Discovery & Fit Analysis (Week 1–2) Stakeholder interviews, current-process mapping, gap analysis against Odoo's standard modules. You get a written scope and cost range - not a guess. ",
        },
        {
          section: "02",
          title: "PHASE - 02",
          description: "Solution Design (Week 3–4) Requirements mapped to specific modules and configurations. We decide what needs custom development and lock a fixed plan before any build starts",
        },
        {
          section: "03",
          title: "PHASE - 03",
          description: "Configuration & Build (Week 5–9) Core modules configured, custom workflows built, integrations connected. Progress reviews every two weeks with working software, not slides",
        },
      ],
    },

    whyBusinessesChoose: {
      title: 'Why Businesses "Choose" GSUS for Odoo Implementation ',
      features: [
        {
          id: 1,
          title: "Business-First Approach ",
          // description: "We understand the process before designing the solution. ",
          icon: businessIcon,
        },
        {
          id: 2,
          title: "Functional + Technical Expertise ",
          // description: "From Odoo configuration to custom development and integrations. ",
          icon: technicalIcon,
        },
        {
          id: 3,
          title: "Industry Understanding ",
          // description: "Implementation designed around real business operations, including manufacturing workflows. ",
          icon: industryIcon,
        },
        {
          id: 4,
          title: "Long-Term Support ",
          // description: "Our relationship doesn't end when the system goes live.",
          icon: supportIcon,
        },
      ],
    },
    operation: {
      title: 'Built for Scalable Business "Operations" ',
      description:
        "Bring all your business operations into one connected system — from sales and inventory to finance and reporting.",
      features: [
        {
          image: odooInterfaceImage,
          title: "User-friendly interface for faster adoption",
          description:
            "Simple and intuitive design that helps your team start using the system with minimal training.",
        },
        {
          image: odooWorkflowImage,
          title: "Flexible system tailored to your workflows",
          description:
            "Adapts to your existing business processes instead of forcing you to change how you work.",
        },
        {
          image: odooManualImage,
          title: "Smart automation to reduce manual effort",
          description:
            "Automates repetitive tasks to save time, reduce errors, and improve overall efficiency.",
        },
        {
          image: odooLowcodeImage,
          title: "Low-code customization for quick changes",
          description:
            "Easily modify features and workflows without heavy development or long delays.",
        },
        {
          image: mobileAccessImage,
          title: "Mobile access for on-the-go control",
          description:
            "Stay connected and manage your business anytime, anywhere from any device.",
        },
        {
          image: productionImage,
          title: "Enterprise-grade security for data protection",
          description:
            "Advanced security measures ensure your business data remains safe, private, and reliable.",
        },
      ],
    },
    measurable: {
      title: 'Delivering ROI with "Measurable" Business',
      description:
        "Transform your business with ERP-driven automation that not only reduces costs but also improves efficiency across every department. With real-time data and streamlined operations, you gain better control, faster decision-making, and measurable results that directly impact your bottom line.",

      features: [
        {
          icon: savingIcon,
          title: "Cost savings from automation",
          description:
            "Eliminate repetitive manual tasks and reduce operational expenses by automating core business processes.",
        },
        {
          icon: increasedIcon,
          title: "Increased operational efficiency",
          description:
            "Streamline workflows and improve productivity across teams with a fully integrated system.",
        },
        {
          icon: decisionIcon,
          title: "Better decision-making with real-time data",
          description:
            "Access accurate, up-to-date insights that help you make faster and smarter business decisions.",
        },
        {
          icon: roiIcon,
          title: "Faster ROI realization",
          description:
            "Experience quicker returns with optimized processes, reduced delays, and improved overall performance.",
        },
      ],
    },

    pricingTimeline: {
      title: 'Transparent ERP Pricing & Clear Implementation "Timelines"',
      description:
        "Make confident decisions with complete clarity on cost and delivery. Our ERP implementation approach is designed to give you full visibility into pricing, timelines, and outcomes—so you know exactly what to expect at every stage, with zero surprises.",
      features: [
        {
          image: businessImage,
          title: "Flexible Pricing based on your business needs",
          description:
            "Choose a pricing model that fit your business size, requirements, and selected modules - no one-size-fits-all approach",
        },
        {
          image: meetingImage,
          title: "Clear cost breakdown",
          description:
            "Get complete transparency on licensing, customization, and implementation costs, so you understand exactly where your investment goes.",
        },
        {
          image: businessPeopleImage,
          title: "Defined implementation timelines",
          description:
            "Know your project milestones in advance with a structured timeline from planning to go-live.",
        },
        {
          image: officeImage,
          title: "No hidden costs — full transparency",
          description:
            "What you see is what you pay. We ensure clear communication with no unexpected charges.",
        },
        {
          image: peopleImage,
          title: "ROI-focused implementation approach",
          description:
            "Every step is aligned to deliver measurable value, helping you achieve faster returns and long-term business growth",
        },
        {
          image: teamImage,
          title: "Dedicated Project Management & Regular Progress Updates",
          description:
            "Stay informed with regular project updates, milestone tracking, and proactive communication throughout implementation.",
        },

        {
          image: teamMeetingImage,
          title: "Post-Go-Live Support & Continuous Optimization",
          description:
            "Receive ongoing support and system enhancements to ensure long-term ERP success and business growth.",
        },
      ],
    },
  },
};
export default erpServices;
